"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParliamentHall = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var Resources_1 = require("../../Resources");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Options_1 = require("../Options");
var ParliamentHall = (function (_super) {
    __extends(ParliamentHall, _super);
    function ParliamentHall() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.PARLIAMENT_HALL,
            tags: [Tags_1.Tags.BUILDING],
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.party(PartyName_1.PartyName.MARS); }),
            metadata: {
                cardNumber: 'T08',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(1).slash().building(3, { played: Options_1.played });
                    });
                }),
                description: 'Requires that Mars First are ruling or that you have 2 delegates there. Increase your M€ production 1 step for every 3 Building tags you have, including this.',
                victoryPoints: 1,
            },
        }) || this;
    }
    ParliamentHall.prototype.produce = function (player) {
        var includeThis = !player.cardIsInEffect(this.name);
        var tagCount = player.getTagCount(Tags_1.Tags.BUILDING) + (includeThis ? 1 : 0);
        var amount = Math.floor(tagCount / 3);
        player.addProduction(Resources_1.Resources.MEGACREDITS, amount, { log: true });
    };
    ParliamentHall.prototype.play = function (player) {
        this.produce(player);
        return undefined;
    };
    ParliamentHall.prototype.getVictoryPoints = function () {
        return 1;
    };
    return ParliamentHall;
}(Card_1.Card));
exports.ParliamentHall = ParliamentHall;
